import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {Link} from 'react-router-dom';
import withNavigate from '../../Common/components/withNavigate';
import ReimbursementStore from '../stores';


const CustomProgressBar = props => {
	const { pages } = props;

    useEffect(() => {
		if(ReimbursementStore.getReimbursementPageStatus(props.page) !== 'stepwizard-step complete') {
			ReimbursementStore.setReimbursementPageStatus(props.page, 'active');
		}
    }, [props.page]);

	return (
		<>
			<div className='stepwizard stepright-12 mb-5 stepwizard-progress'>
				<div className='stepwizard-row'>
					{pages.map(page => {
                        const hrefVal = page.href.replace('#', '/');
						return(
						<Link className={page.state} to={hrefVal} key={page.key}>
							<span className='stepwizard-badge' />
							<span className='stepwizard-title'>{page.title}</span>
						</Link>
					)})}
				</div>
			</div>
		</>
	);
}

CustomProgressBar.propTypes = {
	pages: PropTypes.array,
    page: PropTypes.string
}

export default withNavigate(CustomProgressBar);